import React from 'react';
import { SvgIconProps } from '../types';

export default function Education({
  fill,
  width,
  height,
  className,
  ariaLabel,
  ariaHidden,
}: SvgIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 50 50"
      fill="none"
      width={width}
      height={height}
      className={className}
      aria-label={ariaLabel}
      aria-hidden={ariaHidden}
    >
      <g clip-path="url(#clip0_20708_74875)">
        <path
          d="M25 50C38.8071 50 50 38.8071 50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50Z"
          fill={fill}
        />
        <path
          d="M20.1944 10.5669C19.7829 10.7428 19.3017 10.6598 18.9864 10.3412C18.2065 9.55133 16.9952 9.27255 15.9133 9.73718C14.8314 10.2018 14.1975 11.2704 14.234 12.3789C14.2473 12.8269 13.9751 13.2318 13.5636 13.4077L12.1034 14.0349C11.5425 14.2772 11.2803 14.9277 11.5226 15.4885L12.1432 16.9355C12.3855 17.4964 13.0359 17.7585 13.5968 17.5163L23.1448 13.421C23.7057 13.1787 23.9678 12.5282 23.7256 11.9674L23.105 10.5204C22.8627 9.95953 22.2122 9.69735 21.6514 9.93962L20.1911 10.5669H20.1944Z"
          fill="white"
        />
        <path
          d="M19.9455 41.6301C19.544 41.6301 19.1457 41.5537 18.7607 41.4011C17.9709 41.0858 17.3503 40.4785 17.0151 39.6986L8.67181 20.2442C8.33662 19.461 8.32666 18.5948 8.64194 17.8049C8.95722 17.0151 9.56455 16.3945 10.3444 16.0593L24.3263 10.0623C25.1095 9.72712 25.9757 9.71716 26.7655 10.0324C27.5554 10.3477 28.176 10.9517 28.5112 11.735L36.8545 31.1894C37.5481 32.8056 36.7981 34.684 35.1818 35.3743L21.2 41.3712C20.7951 41.5438 20.3703 41.6301 19.9422 41.6301H19.9455ZM25.5841 11.4595C25.3783 11.4595 25.1759 11.4993 24.9834 11.5856L11.0016 17.5826C10.2283 17.9144 9.86655 18.8138 10.1984 19.5904L18.5417 39.0448C18.701 39.4198 18.9997 39.7085 19.378 39.8612C19.7564 40.0139 20.1712 40.0072 20.5495 39.8479L34.5314 33.851C35.3046 33.5191 35.6664 32.6197 35.3345 31.8431L26.9912 12.3887C26.8319 12.0137 26.5332 11.725 26.1549 11.5723C25.9724 11.4993 25.7799 11.4628 25.5874 11.4628L25.5841 11.4595Z"
          fill="white"
        />
        <path
          d="M43.3394 16.4111L41.5107 14.7816C41.0295 14.3535 40.1965 14.4995 39.6522 15.1135L37.6311 17.3835L40.847 20.1414C40.847 20.1414 38.2949 18.4189 36.37 18.7973L29.9018 26.062C29.7292 26.2545 29.5998 26.4801 29.5268 26.7158L28.3188 30.5788C28.1097 31.2425 28.6606 31.7138 29.2912 31.4118L32.892 29.6927C33.1011 29.5931 33.2969 29.4438 33.4595 29.2646L43.2265 18.2961C43.7708 17.6855 43.8206 16.8425 43.3394 16.4111Z"
          fill="white"
        />
        <path
          d="M13.9022 22.7963C13.64 22.7963 13.3944 22.6403 13.2882 22.3847C13.1488 22.0462 13.3081 21.6579 13.6466 21.5185L21.2698 18.3724C21.6083 18.233 21.9966 18.3923 22.1359 18.7341C22.2753 19.0726 22.116 19.4609 21.7775 19.6003L14.1544 22.7465C14.0714 22.7797 13.9851 22.7963 13.9022 22.7963Z"
          fill="white"
        />
        <path
          d="M25.6703 19.4512L23.5928 18.8903C23.2377 18.7941 23.0286 18.429 23.1249 18.0772C23.2211 17.7221 23.5828 17.5131 23.9379 17.6093L24.7344 17.825L25.5044 14.9809C25.6006 14.6258 25.9624 14.4167 26.3175 14.5129C26.6726 14.6092 26.8817 14.9742 26.7854 15.326L25.6703 19.4512Z"
          fill="white"
        />
        <path
          d="M16.6932 29.1019C16.431 29.1019 16.1854 28.9459 16.0792 28.6904C15.9398 28.3519 16.0991 27.9636 16.4377 27.8242L24.0608 24.6781C24.3993 24.5387 24.7876 24.698 24.927 25.0398C25.0664 25.3816 24.9071 25.7666 24.5685 25.906L16.9454 29.0521C16.8624 29.0853 16.7762 29.1019 16.6932 29.1019Z"
          fill="white"
        />
        <path
          d="M19.7166 35.5237C19.4578 35.5237 19.2155 35.3744 19.106 35.1222C18.9633 34.7837 19.1193 34.3954 19.4545 34.2493L26.1019 31.4052C26.4404 31.2625 26.8287 31.4185 26.9747 31.7537C27.1174 32.0922 26.9614 32.4805 26.6262 32.6265L19.9788 35.4706C19.8925 35.5071 19.8062 35.5237 19.7166 35.5237Z"
          fill="white"
        />
        <path
          d="M28.4615 25.7566L26.3839 25.1957C26.0288 25.0995 25.8198 24.7344 25.916 24.3827C26.0122 24.0276 26.374 23.8185 26.7291 23.9147L27.5256 24.1304L28.2922 21.2863C28.3885 20.9312 28.7502 20.7221 29.1053 20.8183C29.4604 20.9146 29.6695 21.2796 29.5732 21.6314L28.4581 25.7566H28.4615Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_20708_74875">
          <rect width="50" height="50" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
